export const TOOLTIP_CARD_HEIGHT_OFFSET = 125;
export const OFFSSET_HEIGHT = 70;
export const DEAFAULT_CARD_HEIGHT = 200;
export const SMALL_DEVICE_HEIGHT = 600;
